var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGift = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 56,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCC5C",
  d: "M43.313 20.22h-33.25a1.75 1.75 0 0 0-1.75 1.75v5.25a1.75 1.75 0 0 0 1.75 1.75h33.25a1.75 1.75 0 0 0 1.75-1.75v-5.25a1.75 1.75 0 0 0-1.75-1.75"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F7B546",
  d: "M43.313 20.22h-3.5a1.75 1.75 0 0 1 1.75 1.75v5.25a1.75 1.75 0 0 1-1.75 1.75h3.5a1.75 1.75 0 0 0 1.75-1.75v-5.25a1.75 1.75 0 0 0-1.75-1.75"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCC5C",
  d: "M28.438 28.97h13.125v19.25a1.75 1.75 0 0 1-1.75 1.75h-26.25a1.75 1.75 0 0 1-1.75-1.75V28.97h13.125"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#F7B546",
  d: "M38.063 28.97h-26.25v3.5h19.25a7 7 0 0 1 7 7v10.5h1.75a1.75 1.75 0 0 0 1.75-1.75V28.97z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#F04C4D",
  d: "M22.313 11.47a4.374 4.374 0 1 0 0 8.75h4.375v-4.375a4.375 4.375 0 0 0-4.375-4.376m2.625 7h-2.625a2.625 2.625 0 1 1 2.625-2.625zm6.125-7a4.375 4.375 0 0 0-4.375 4.374v4.376h4.375a4.376 4.376 0 0 0 0-8.75m0 7h-2.625v-2.625a2.625 2.625 0 1 1 2.625 2.624"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#E13340",
  d: "M31.063 18.47h.875a2.625 2.625 0 1 0 0-5.25c-.151 0-.294.019-.438.043a2.62 2.62 0 0 1-.437 5.207m-8.75-5.25h-.875a2.625 2.625 0 0 0 0 5.25c.15 0 .294-.02.437-.044a2.62 2.62 0 0 1 .438-5.206"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#F04C4D",
  d: "M24.938 20.22h3.5v29.75h-3.5z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCC5C",
  d: "m39.638 9.544 2.8-.7-2.8-.7-.7-2.8-.7 2.8-2.8.7 2.8.7.7 2.8zm3.15 4.9 1.4-.35-1.4-.35-.35-1.4-.35 1.4-1.4.35 1.4.35.35 1.4zm1.75-7 1.4-.35-1.4-.35-.35-1.4-.35 1.4-1.4.35 1.4.35.35 1.4z"
})));
export default SvgGift;